/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Row_WindInputs */

const en_ui_weather_row_wind = /** @type {(inputs: Ui_Weather_Row_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wind`)
};

const de_ui_weather_row_wind = /** @type {(inputs: Ui_Weather_Row_WindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wind`)
};

/**
* | output |
* | --- |
* | "Wind" |
*
* @param {Ui_Weather_Row_WindInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_row_wind = /** @type {((inputs?: Ui_Weather_Row_WindInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Row_WindInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_row_wind(inputs)
	return de_ui_weather_row_wind(inputs)
});